export function isSelfRegistrationEnabled() {

    return process.env.VUE_APP_SELF_REGISTRATION_ENABLED !== 'false';

}

export function requestAccountWhatsappUrl(message) {

    const number = (process.env.VUE_APP_WHATSAPP_NUMBER || '').replace(/[^0-9]/g, '');
    const base = 'https://wa.me/' + number;

    return message ? `${base}?text=${encodeURIComponent(message)}` : base;

}
